export default __webpack_public_path__ + "static/media/Ballroll_00230.6ac5bb2f.png";